// src/components/HeaderStyles.ts
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Select from "../UI/Select/Select.tsx"; // Ваш кастомный селект
import Icon from "../UI/Icon/Icon.tsx";       // Ваш универсальный Icon

/**
 * Общий контейнер хедера
 */
export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: 55,
  //padding: theme.spacing(0, 2),
  backgroundColor: theme.palette.background.regular,
  borderBottom: `1px solid ${theme.palette.border?.[10] || "#E5E7EB"}`,
}));

export const LeftSection = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
  paddingLeft: '17px',
  
}));

export const RightSection = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: 'flex-end'
}));

/**
 * «Пилюля» (капсула) для селекта подразделений
 */
export const PillSelectContainer = styled(Box)(({ theme }) => ({
  height: 34,
  gap: "12px",
  borderRadius: 24,
  backgroundColor: theme.palette.background.regular,
  display: "flex",
  alignItems: "center",
}));

/**
 * Универсальная «пилюля» (капсула) для локации, даты, пользователя и т.д.
 */
export const Location = styled(Box)(({ theme }) => ({
    height: 34,
    padding: "8px 16px 8px 0",
    borderRadius: 24,
    backgroundColor: theme.palette.background.regular,
    display: "flex",
    alignItems: "center",
    marginRight: '10px'
  }));
export const Time = styled(Box)(({ theme }) => ({
    height: 34,
    padding: "8px 16px 8px 0",
    borderRadius: 24,
    backgroundColor: theme.palette.background.regular,
    display: "flex",
    alignItems: "center",
    marginRight: '32px'
  }));
export const Pill = styled(Box)(({ theme }) => ({
  height: 34,
  padding: "8px 16px 8px 0",
  borderRadius: 24,
  backgroundColor: theme.palette.background.regular,
  display: "flex",
  alignItems: "center",
  //marginLeft: '33px'
}));
export const PillSector = styled(Box)(({ theme }) => ({
   marginRight: "9px"
  }));
/**
 * Текст по макету (Inter, 15px, line-height: 100%, weight 500)
 */
export const HeaderText = styled(Typography)(({ theme }) => ({
  fontFamily: "Inter, sans-serif",
  fontWeight: 500,
  fontSize: 15,
  lineHeight: "100%",
  letterSpacing: 0,
  color: theme.palette.TextAndIcon?.primaryBlackBlueEnabled || "#000",
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  height: 40,
  width: 40,
  border: `1px solid ${theme.components?.select?.borderEnabled || "#E5E7EB"}`,
}));

/**
 * Стилизованный селект для пользователя, 
 * чтобы показывать только стрелку (SVG), а не текст.
 */
export const UserSelect = styled(Select)(({ theme }) => ({
  width: 20, // Селект узкий, чтобы видна была только стрелка
  appearance: "none",
  WebkitAppearance: "none",
  MozAppearance: "none",
  "&::-ms-expand": {
    display: "none",
  },
  border: "none",
  background: "transparent",
  cursor: "pointer",
}));

/** Пример иконки через ваш Icon — если захотите отдельно стилизовать */
export const StyledIcon = styled(Icon)(() => ({
  marginRight: 8,
}));
